import { apiService } from '../lib/api';
import { ContactRequest, ContactResponse } from '../types/contact';

class ContactService {
  
  async submitContactForm(contactData: ContactRequest): Promise<ContactResponse> {
    try {
      const response = await apiService.post<ContactResponse>('/support/contact', contactData);
      return response;
    } catch (error) {
      console.error('Error submitting contact form:', error);
      throw error;
    }
  }
}

export const contactService = new ContactService();
